import { render, staticRenderFns } from "./userMy_userinfo.vue?vue&type=template&id=70c46eff&scoped=true"
import script from "./userMy_userinfo.vue?vue&type=script&lang=js"
export * from "./userMy_userinfo.vue?vue&type=script&lang=js"
import style0 from "./userMy_userinfo.vue?vue&type=style&index=0&id=70c46eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c46eff",
  null
  
)

component.options.__file = "userMy_userinfo.vue"
export default component.exports